module.exports = __webpack_public_path__ + "static/img/choice.c76a10df.svg";